var map = {
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"dashboard-dashboard-module"
	],
	"./modules/categoria/categoria.module": [
		"./src/app/modules/categoria/categoria.module.ts",
		"modules-categoria-categoria-module"
	],
	"./modules/countries/countries.module": [
		"./src/app/modules/countries/countries.module.ts",
		"common",
		"modules-countries-countries-module"
	],
	"./modules/denuncias/denuncias.module": [
		"./src/app/modules/denuncias/denuncias.module.ts",
		"modules-denuncias-denuncias-module"
	],
	"./modules/home/home.module": [
		"./src/app/modules/home/home.module.ts",
		"common",
		"modules-home-home-module"
	],
	"./modules/list-post/list-post.module": [
		"./src/app/modules/list-post/list-post.module.ts",
		"common",
		"modules-list-post-list-post-module"
	],
	"./modules/list-posts/list-posts.module": [
		"./src/app/modules/list-posts/list-posts.module.ts",
		"common",
		"modules-list-posts-list-posts-module"
	],
	"./modules/list-users/list-users.module": [
		"./src/app/modules/list-users/list-users.module.ts",
		"default~modules-list-users-list-users-module~modules-statistics-statistics-module~modules-users-users-module",
		"modules-list-users-list-users-module"
	],
	"./modules/message/message.module": [
		"./src/app/modules/message/message.module.ts",
		"modules-message-message-module"
	],
	"./modules/notifications/notifications.module": [
		"./src/app/modules/notifications/notifications.module.ts",
		"modules-notifications-notifications-module"
	],
	"./modules/novelties/novelties.module": [
		"./src/app/modules/novelties/novelties.module.ts",
		"modules-novelties-novelties-module"
	],
	"./modules/products/products.module": [
		"./src/app/modules/products/products.module.ts",
		"modules-products-products-module"
	],
	"./modules/statistics/statistics.module": [
		"./src/app/modules/statistics/statistics.module.ts",
		"default~modules-list-users-list-users-module~modules-statistics-statistics-module~modules-users-users-module",
		"common",
		"modules-statistics-statistics-module"
	],
	"./modules/users/users.module": [
		"./src/app/modules/users/users.module.ts",
		"default~modules-list-users-list-users-module~modules-statistics-statistics-module~modules-users-users-module",
		"modules-users-users-module"
	],
	"./pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"common",
		"pages-pages-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;